<script lang="ts" setup>
const { locale } = useI18n()

const isOpen = ref(false)

function onClick() {
  isOpen.value = !isOpen.value
}
</script>

<template>
  <div class="not-prose my-6 flex cursor-pointer flex-col divide-y divide-gray-200 rounded-lg border border-gray-300 px-4 text-left text-base md:text-lg dark:divide-gray-800 dark:border-gray-700">
    <div
      class="flex items-center justify-between py-6"
      @click="onClick"
    >
      <span class="flex-1 text-gray-900 dark:text-white">
        <MDCSlot :name="`label-${locale}`" />
      </span>

      <UIcon
        class="size-5 flex-initial flex-shrink-0 text-gray-900 transition-transform duration-200 dark:text-gray-100"
        :class="{ 'rotate-90': isOpen }"
        :name="getIcon('chevronRight')"
      />
    </div>

    <div
      v-if="isOpen"
      class="py-6 text-gray-500 dark:text-gray-400"
    >
      <MDCSlot :name="`content-${locale}`" />
    </div>
  </div>
</template>
